import { Badge } from '@/components/ui/badge';
import { Crown, Shield, ShieldCheck, User } from 'lucide-react';
import type { GuildMemberRole } from '@/lib/api';

interface GuildRoleBadgeProps {
  role: GuildMemberRole;
}

const roleConfig: Record<
  GuildMemberRole,
  {
    label: string;
    icon: typeof Crown;
    variant: 'default' | 'secondary' | 'outline' | 'destructive';
  }
> = {
  owner: { label: 'Owner', icon: Crown, variant: 'default' },
  admin: { label: 'Admin', icon: Shield, variant: 'secondary' },
  moderator: { label: 'Mod', icon: ShieldCheck, variant: 'outline' },
  member: { label: 'Member', icon: User, variant: 'outline' },
};

const fallbackConfig = { label: 'Unknown', icon: User, variant: 'outline' as const };

export function GuildRoleBadge({ role }: GuildRoleBadgeProps) {
  const config = roleConfig[role] ?? fallbackConfig;
  const Icon = config.icon;
  return (
    <Badge variant={config.variant} className="text-xs">
      <Icon className="h-3 w-3 mr-1" />
      {config.label}
    </Badge>
  );
}
